import { get } from 'lodash';

const root = state => get(state, 'CommonState.gridPreference');

export const getPreferenceJson = state => get(root(state), 'preferenceJson');
export const getPreferenceJsonError = state =>
  get(root(state), 'preferenceJsonError');
export const getLoading = state => get(root(state), 'loading');
export const getIsSubmitting = state => get(root(state), 'isSubmitting');
export const getSubmitting = state => get(root(state), 'submitting');
export const getSubmitted = state => get(root(state), 'submitted');
export const getSubmitError = state => get(root(state), 'submitError');



// WEBPACK FOOTER //
// ./src/state/gridPreference/selectors.js